import {Box, BoxProps, AspectRatio, Tooltip} from '@chakra-ui/react';

type HandleProps = BoxProps & {
  tooltipLabel: string,
  color: string;
}

export default function Handle({tooltipLabel, color, ...boxProps}: HandleProps) {
  return (
    <AspectRatio ratio={3/1} w="full">
      <Tooltip label={tooltipLabel}>
        <Box
          role="presentation"
          position="relative"
          borderStyle="solid"
          borderColor={color}
          borderTopWidth="1px"
          borderBottomWidth="1px"
          {...boxProps}
          _before={{
            content: '""',
            display: 'block',
            position: 'absolute',
            top: '50%',
            w: 'full',
            borderStyle: 'solid',
            borderColor: color,
            borderTopWidth: '1px'
          }}
        ></Box>
      </Tooltip>
    </AspectRatio>
  );
}
